import { SxProps, SystemStyleObject } from "@mui/system";
import type { ThemeV2 } from "../../../util/types";

export const starIconStyle = ({
  maxStars,
  theme,
}: {
  maxStars: number;
  theme: ThemeV2;
}): SystemStyleObject => ({
  fontSize:
    maxStars >= 10
      ? {
          sm: `${theme.tokens.typography.size.xl * 1.6}px`,
          xs: `${theme.tokens.typography.size.xl * 1.2}px`,
        }
      : {
          sm: `${theme.tokens.typography.size.xl * 3.2}px`,
          xs: `${theme.tokens.typography.size.xl * 2}px`,
        },
  color: theme.tokens.color.action.primary,
});

export const starIconWraper = (height?: number): SxProps => ({
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  display: "flex",
  alignItems: "center",
  height: height ? `${height}px` : "auto",
  justifyContent: "center",
});

export const starDividerStyle = (
  theme: ThemeV2,
  showDividers: boolean,
): SystemStyleObject =>
  showDividers
    ? {
        alignItems: "stretch",
        "& > label:not(.MuiRating-pristine)": {
          alignItems: "center",
          borderLeft: `1px solid ${theme.tokens.color.action.primary}`,
          minHeight: `${theme.tokens.spacing["5"] * 3}px`,
        },
        "& > label:not(.MuiRating-pristine):first-of-type": {
          borderLeft: 0,
        },
      }
    : {};
